import { Field } from "formik";
import React, { useState } from "react";
import { colors } from "../../../../assets/themes";
import { Icon, Input, Steps } from "../../../../components";
import { STEPS } from "../../../../components/Styles/variants";
import { useCategoryForm } from "../../../../modules/hooks";
import polyglot from "../../../../utils/polyglot";
import AddressModal from "../../../common/AddressModal";

const FormAddressFromTo = () => {
  const { addresses } = useCategoryForm();
  const [addressModalIsOpen, setAddressModalIsOpen] = useState(false);
  const [destinationAddressModalIsOpen, setDestinationAddressModalIsOpen] =
    useState(false);

  return (
    <>
      <Steps orientation={STEPS.ORIENTATION.VERTICAL}>
        <Steps.Step
          title={polyglot.t("common.start_place")}
          active
          renderLineColor={colors.mutedLight}
          render={() => (
            <Icon.XLarge name="circle-small-solid" color={colors.mutedLight} />
          )}
        >
          <Field name="address">
            {({ field }) => (
              <Input
                name={field.name}
                onClick={() => setAddressModalIsOpen(true)}
                value={field.value}
                placeholder={polyglot.t("common.placeholder.address")}
                RightComponent={() => <Icon.Medium name="dropdown" />}
              />
            )}
          </Field>
          {/* <Field name="destination_same">
            {({ field, form }) => (
              <Checkbox
                {...field}
                checked={field.value === true}
                onChange={() => form.setFieldValue(field.name, !field.value)}
              >
                La destination identique au lieu de départ
              </Checkbox>
            )}
          </Field> */}
        </Steps.Step>

        <Steps.Step
          title={polyglot.t("common.destination_place")}
          active
          renderLineColor={colors.mutedLight}
          render={() => <Icon.XLarge name="circle" color={colors.primary} />}
        >
          <Field name="destination_address">
            {({ field }) => (
              <Input
                name={field.name}
                onClick={() => setDestinationAddressModalIsOpen(true)}
                value={field.value}
                placeholder={polyglot.t("common.placeholder.address")}
                RightComponent={() => <Icon.Medium name="dropdown" />}
              />
            )}
          </Field>
        </Steps.Step>
      </Steps>
      {addressModalIsOpen && (
        <AddressModal
          addresses={addresses}
          isOpen={addressModalIsOpen}
          onClose={() => setAddressModalIsOpen(false)}
        />
      )}
      {destinationAddressModalIsOpen && (
        <AddressModal
          isDestination
          addresses={addresses}
          isOpen={destinationAddressModalIsOpen}
          onClose={() => setDestinationAddressModalIsOpen(false)}
        />
      )}
    </>
  );
};

export default FormAddressFromTo;
